import { EventOrganizer } from '@smarthead-api/models/event-organizer';
import { SearchItem } from '@smarthead-api/models/search-item';

import { ActivityUtils } from './activity-utils';
import { BasicEntityEnum, BasicEntityUtils } from './basic-entity-utils';
import { ProfileUtils } from './profile-utils';

export interface SearchItemExtended extends SearchItem {
  realId: number;
  // !!! extend type by special parameters need only for view purpose and caching of some properties ...
  logoPath: string | null;
  convertedType: BasicEntityEnum;
  // for activity
  defaultOrganizer: EventOrganizer;
  organizerTitle: string;
  organizerLogoPath: string | null;
}

export namespace SearchUtils {
  import stringToEntity = BasicEntityUtils.stringToEntity;

  /**
   * Process search items and add required fields for view (re-type type of item, logo image, ...)
   */
  export const processSearchItems = (searchItems: SearchItemExtended[]): void => {
    for (const searchItem of searchItems) {
      // for each found result create image (logo/avatar) path
      searchItem.convertedType = stringToEntity(searchItem.type);
      switch (searchItem.convertedType) {
        case BasicEntityEnum.CARD: // PROFILE
          searchItem.realId = parseInt(searchItem.id.replace('profile-', ''), 10);
          searchItem.logoPath = ProfileUtils.getProfileLogo(searchItem.realId, searchItem.imageType, searchItem.profileLogoVersion, searchItem.hasLogo, true);
          break;
        case BasicEntityEnum.EVENT: // ACTIVITY
          searchItem.realId = parseInt(searchItem.id.replace('activity-', ''), 10);
          searchItem.logoPath = ActivityUtils.getActivityLogo(searchItem.realId, searchItem.imageType, searchItem.activityLogoVersion, searchItem.hasLogo);
          // activity has also organizer -> extract organizer (default) from array and image (avatar) path
          if (searchItem.organizers) {
            const organizer = ActivityUtils.extractOrganizer(searchItem.organizers);
            if (organizer) {
              searchItem.defaultOrganizer = organizer;
              searchItem.organizerTitle = organizer.text;
              searchItem.organizerLogoPath = ActivityUtils.extractDefaultOrganizerLogoPath(searchItem.organizers);
            }
          }
          break;
      }
    }
  };
}
